import * as React from 'react';
import { useProductDetailSlots } from '@grandvisionhq/fun-products';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';
import { UnpublishedPDP } from '../UnpublishedPDP.js';

const UnpublishedPDPGuard = ({ children , brandPromotions ,  })=>{
    const { product , activeVariant , productUrl  } = useProductDetailContext();
    const { Slots  } = useProductDetailSlots();
    return !product.published || !activeVariant.isPublished ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(UnpublishedPDP, {
        productUrl: productUrl,
        brandPromotions: brandPromotions
    }), Slots.SecondaryProductInfoSlot && /*#__PURE__*/ React.createElement(Slots.SecondaryProductInfoSlot, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};

export { UnpublishedPDPGuard };
//# sourceMappingURL=UnpublishedPDPGuard.js.map
